export const draftReply = "phCJRd";
export const replyPromptText = "n1pLue";
export default {draftReply,replyPromptText};